import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { FalconsSiteNavigationFragment } from '../../../graphql-types';
import { FalconHeader } from '../Falcons';
import { HeaderData } from '../Falcons/Header/types';

const FalconsHeaderAdapter = () => {
  const result = useStaticQuery<FalconsSiteNavigationFragment>(graphql`
    query {
      ...FalconsSiteNavigation
    }
  `);

  const parsedData = React.useMemo(() => {
    if (result?.contentfulSiteData?.navigation?.internal?.content) {
      return JSON.parse(
        result?.contentfulSiteData.navigation.internal.content,
      ) as HeaderData;
    }
    return null;
  }, [result?.contentfulSiteData?.navigation?.internal?.content]);

  if (!parsedData) {
    return null;
  }

  return <FalconHeader nav={parsedData.nav} />;
};

export default FalconsHeaderAdapter;
